import * as types from '../mutation-types'
import settingService from '../../services/settings'

const state = {
    loading: false,
    errors: null,
    settings: {},
    darkmode: null,
}

const actions = {
    setDarkMode({ commit }, val) {
        commit("SET_DARKMODE", val)
    },
    getAll({ commit }) {
        commit(types.SETTING_LOADING, true)
        settingService.getAll().then(
            response => {

                commit(types.LOAD_SETTINGS, response.data)
                commit(types.SETTING_LOADING, false)
                commit(types.SETTING_FAILURE, null)
            },
            error => {
                commit(types.SETTING_FAILURE, error)
                commit(types.SETTING_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
       // console.log("ttutuuututu", data)
        commit(types.SETTING_LOADING, true)
        commit(types.SETTING_FAILURE, null)
        return settingService.add(data).then(
            response => {
                //console.log('responseooo', response)

                commit(types.ADD_SETTING, response.data)
                commit(types.SETTING_LOADING, false)

            },
            error => {
                commit(types.SETTING_FAILURE, error)
                commit(types.SETTING_LOADING, false)
            }
        )
    },


}

const mutations = {
    [types.ADD_SETTING](state, payload) {
        state.settings = payload;
    },
    [types.LOAD_SETTINGS](state, payload) {
        state.settings = payload
    },

    [types.SETTING_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.SETTING_LOADING](state, payload) {
        state.loading = payload
    },
    SET_DARKMODE(state, payload) {
        state.darkmode = payload
    }
}

const getters = {
    SETTINGS: state => {
        return state.settings
    },

    SETTING_ERROR: state => {
        return state.errors
    },

    SETTING_LOADING: state => {
        return state.loading
    },
    DARKMODE: state => {
        return state.darkmode
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/settings.js